module.exports = __webpack_public_path__ + "img/Adlabs.ae9fb840.png";